import { render } from "./VueSplash.vue?vue&type=template&id=4d04f0ac&scoped=true"
import script from "./VueSplash.vue?vue&type=script&lang=js"
export * from "./VueSplash.vue?vue&type=script&lang=js"

import "./VueSplash.vue?vue&type=style&index=0&id=4d04f0ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d04f0ac"]])

export default __exports__